import React, { createContext, useContext, useState, useEffect } from "react";
import { getCurrentUserData } from "../services/settingsServise/settingsServise";

type User = {
  firstName: string;
  lastName: string;
  email: string;
} | null;

interface UserContextValue {
  user: User;
  setUser: (user: User) => void;
  reloadUser: () => Promise<void>;
}

const UserContext = createContext<UserContextValue | null>(null);

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User>(null);

  const reloadUser = async () => {
    try {
      const data = await getCurrentUserData();
      setUser({
        firstName: data.first_name || "Name",
        lastName: data.last_name || "Lastname",
        email: data.email || "",
      });
    } catch (error) {
      console.error("Ошибка загрузки данных пользователя:", error);
      setUser(null);
    }
  };

  useEffect(() => {
    reloadUser();
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser, reloadUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const ctx = useContext(UserContext);
  if (!ctx) throw new Error("useUser must be used within UserProvider");
  return ctx;
};

